import "core-js/modules/es.regexp.constructor";
import "core-js/modules/es.regexp.to-string";
var VERSION = '1.1.0';

function getTime(time) {
  if (typeof time === 'number') return time;

  if (typeof time === 'string' && /([.\d]+)([DdSsHhMm])$/.test(time)) {
    var value = +RegExp.$1;
    var t;

    switch (RegExp.$2.toLocaleLowerCase()) {
      case 'd':
        t = value * 24 * 60 * 60 * 1000;
        break;

      case 'h':
        t = value * 60 * 60 * 1000;
        break;

      case 'm':
        t = value * 60 * 1000;
        break;

      case 's':
        t = value * 1000;
        break;

      default:
        break;
    }

    return Date.now() + t;
  }

  throw new Error("\u65E0\u6548\u7684\u65F6\u95F4" + time);
}

function createCache(api) {
  return {
    get(key, options) {
      if (options === void 0) {
        options = {
          version: VERSION,
          time: '7d'
        };
      }

      var _options = options,
          _options$version = _options.version,
          version = _options$version === void 0 ? VERSION : _options$version;

      try {
        var item = api.getItem(key);

        if (item) {
          var _data = JSON.parse(item);

          if (_data && _data.version === version) {
            // eslint-disable-line
            if (_data.expires !== -1 && _data.expires < Date.now()) {
              this.remove(key);
              return undefined;
            }

            return _data.value;
          }
        }

        return undefined;
      } catch (error) {
        return undefined;
      }
    },

    set(key, data, options) {
      if (options === void 0) {
        options = {
          version: VERSION,
          time: '7d'
        };
      }

      var _options2 = options,
          _options2$version = _options2.version,
          version = _options2$version === void 0 ? VERSION : _options2$version,
          _options2$time = _options2.time,
          time = _options2$time === void 0 ? '7d' : _options2$time;

      try {
        data = {
          version,
          value: data,
          expires: +getTime(time)
        };
        api.setItem(key, JSON.stringify(data));
        return true;
      } catch (error) {
        if (error.name === 'QuotaExceededError') {
          this.clear();
          return this.set(key, data, options);
        }

        return false;
      }
    },

    clear() {
      try {
        api.clear();
        return true;
      } catch (error) {
        return false;
      }
    },

    remove(key) {
      try {
        api.removeItem(key);
        return true;
      } catch (error) {
        return false;
      }
    }

  };
}

var MenoryStorage = /*#__PURE__*/function () {
  function MenoryStorage() {
    this.cache = {};
  }

  var _proto = MenoryStorage.prototype;

  _proto.getItem = function getItem(key) {
    if (key in this.cache) {
      return this.cache[key];
    }

    return null;
  };

  _proto.setItem = function setItem(key, data) {
    this.cache[key] = JSON.stringify(data);
  };

  _proto.removeItem = function removeItem(key) {
    delete this.cache[key];
  };

  _proto.clear = function clear() {
    this.cache = {};
  };

  return MenoryStorage;
}();

export var localCache;
export var sessionCache;

if (typeof window === 'undefined') {
  var cache = {
    get() {
      return undefined;
    },

    set() {},

    clear() {},

    remove() {}

  };
  localCache = cache;
  sessionCache = cache;
} else {
  localCache = createCache(localStorage);
  sessionCache = createCache(sessionStorage);
}

export var menoryCache = createCache(new MenoryStorage());